<template>
    <div class="content-wrapper">
        <div class="content-header">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <h1>My Profile</h1>
                    </div>

                </div>
            </div>
        </div>

        <div id="overlay" v-if="processingAPI">
            <div class="spinner"></div>
            <span class="text-center badge bg-green fs-14" style="margin-top:110px;">Processing...</span>
        </div>

        <div class="content">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="">
                                    <label>Account ID: </label> <span><strong>{{formProfile.borrower_id}}</strong></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title align-middle">
                                <span class="fs-18 bold align-middle">Basic Information</span>
                            </div>
                            <div class="card-tools">
                                <button type="button" class="btn btn-primary btn-sm" data-toggle="modal" data-target="#modalBasicInfo" @click="editBI=true">
                                    <i class="fas fa-external-link-alt mr-1"></i>Edit
                                </button>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>First Name</label>
                                        <input class="form-control form-control-sm" type="text" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)" v-model='formProfile.fname'>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Middle Name</label>
                                        <input class="form-control form-control-sm" type="text" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)" v-model="formProfile.mname">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Last Name</label>
                                        <input class="form-control form-control-sm" type="text" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)" v-model='formProfile.lname'>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>Suffix</label>
                                        <input class="form-control form-control-sm" type="text" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)" v-model='formProfile.suffix_desc'>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-2">
                                    <div class="form-group">
                                        <label>Birth Date</label>
                                        <input type="text" class="form-control form-control-sm" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)" v-model="formProfile.bdate_holder">
                                    </div>
                                </div>

                                <div class="col-sm-2">
                                    <div class="form-group">
                                        <label>Sex</label>
                                        <input class="form-control form-control-sm" type="text" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)" v-model='formProfile.gender_desc'>
                                    </div>
                                </div>

                                <div class="col-sm-3">

                                    <div class="form-group">
                                        <label>Civil Status</label>
                                        <input class="form-control form-control-sm" type="text" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)" v-model='formProfile.cs_desc'>
                                    </div>

                                </div>
                                <div class="col-sm-5">

                                    <div class="form-group">
                                        <label>Place of Birth</label>
                                        <input class="form-control form-control-sm" type="text" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)" :value="formProfile.province_birth + ' ' + formProfile.city_birth">
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row" v-if="formProfile.cs_code=='CS002'">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title align-middle">
                                <span class="fs-18 bold align-middle">Spouse Information</span>
                            </div>
                            <div class="card-tools">
                                <button type="button" class="btn btn-primary btn-sm" data-toggle="modal" data-target="#modalSpouseInfo" @click="editSP=true">
                                    <i class="fas fa-external-link-alt mr-1"></i>Edit
                                </button>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>First Name</label>
                                        <input class="form-control form-control-sm" type="text" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)" v-model='formProfile.sp_fname'>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Middle Name</label>
                                        <input class="form-control form-control-sm" type="text" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)" v-model="formProfile.sp_mname">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Last Name</label>
                                        <input class="form-control form-control-sm" type="text" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)" v-model='formProfile.sp_lname'>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>Suffix</label>
                                        <input class="form-control form-control-sm" type="text" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)" v-model='formProfile.sp_suffix_desc'>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>Birth Date</label>
                                        <input type="text" class="form-control form-control-sm" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)" v-model="formProfile.sp_bdate_holder">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title align-middle">
                                <span class="fs-18 bold align-middle">Contact Information</span>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Email Address</label>
                                        <div class="input-group">
                                            <input type="text" class="form-control form-control-sm" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)" v-model="formProfile.email">
                                            <div class="input-group-append ml-2">
                                                <button type="button" class="btn btn-primary btn-sm" data-toggle="modal" data-target="#modalEmail" @click="editEmail=true">
                                                    <i class="fas fa-external-link-alt mr-1"></i>Edit
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Mobile No.</label>
                                        <div class="input-group">
                                            <input type="text" class="form-control form-control-sm" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)" v-model="formProfile.mobile_number" v-input-mask data-inputmask-mask="(9999) 9999999" data-inputmask-placeholder="">
                                            <div class="input-group-append ml-2">
                                                <button type="button" class="btn btn-primary btn-sm" @click="showMobileNo">
                                                    <i class="fas fa-external-link-alt mr-1"></i>Edit
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title align-middle">
                                <span class="fs-18 bold align-middle">Address Information</span>
                            </div>
                            <div class="card-tools">
                                <button type="button" class="btn btn-primary btn-sm" @click="showModalAddress">
                                    <i class="fas fa-external-link-alt mr-1"></i>Edit
                                </button>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>Province</label>
                                        <input class="form-control form-control-sm" type="text" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)" v-model='formProfile.province'>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>City/Municipality</label>
                                        <input class="form-control form-control-sm" type="text" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)" v-model="formProfile.city">
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>Barangay</label>
                                        <input class="form-control form-control-sm" type="text" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)" v-model='formProfile.bname'>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>House No/Block & Lot/Building</label>
                                        <input class="form-control form-control-sm" type="text" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)" v-model='formProfile.bldg'>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>Street Name / Subdivision</label>
                                        <input class="form-control form-control-sm" type="text" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)" v-model="formProfile.street_address">
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>Ownership</label>
                                        <input class="form-control form-control-sm" type="text" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)" v-model='formProfile.owner_desc'>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <!-- <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title align-middle">
                                <span class="fs-18 bold align-middle">Business Information</span>
                            </div>
                            <div class="card-tools">
                                <button type="button" class="btn btn-primary btn-sm" @click="showModalBusiness">
                                    <i class="fas fa-external-link-alt mr-1"></i>Edit
                                </button>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-8">
                                    <div class="form-group">
                                        <label>Business Name</label>
                                        <input class="form-control form-control-sm text-uppercase" type="text" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)" v-model='formBus.business_name'>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>Total Years in Business</label>
                                        <input class="form-control form-control-sm" type="text" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)" v-model="formBus.total_years">
                                    </div>
                                </div>

                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>Province</label>
                                        <input class="form-control form-control-sm" type="text" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)" v-model='formBus.bus_province'>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>City/Municipality</label>
                                        <input class="form-control form-control-sm" type="text" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)" v-model="formBus.bus_city">
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>Barangay</label>
                                        <input class="form-control form-control-sm" type="text" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)" v-model='formBus.bus_bname'>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>House No/Block & Lot/Building</label>
                                        <input class="form-control form-control-sm" type="text" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)" v-model='formBus.bus_bldg'>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>Street Name / Subdivision</label>
                                        <input class="form-control form-control-sm" type="text" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)" v-model="formBus.bus_street_address">
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>Ownership</label>
                                        <input class="form-control form-control-sm" type="text" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)" v-model='formBus.owner_desc'>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->





        </div>

        <section>
            <div class="modal fade" id="modalBasicInfo" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">>
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title bold">Edit Basic Information</h5>
                        </div>
                        <div class="modal-body">
                            <div class="form-group">
                                <label>First Name</label>
                                <input class="form-control form-control-sm" type="text" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)" v-model='formUpdate.fname'>
                            </div>
                            <div class="form-group">
                                <label>Middle Name</label>
                                <input class="form-control form-control-sm" type="text" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)" v-model="formUpdate.mname">
                            </div>
                            <div class="form-group">
                                <label>Last Name</label>
                                <input class="form-control form-control-sm" type="text" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)" v-model='formUpdate.lname'>
                            </div>
                            <div class="form-group">
                                <label>Suffix</label>
                                <input class="form-control form-control-sm" type="text" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)" v-model='formUpdate.suffix_desc'>
                            </div>
                            <div class="form-group">
                                <label>Birth Date</label>
                                <input type="text" class="form-control form-control-sm" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)" v-model="formUpdate.bdate_holder">
                            </div>
                            <div class="form-group">
                                <label>Sex</label>
                                <input class="form-control form-control-sm" type="text" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)" v-model='formUpdate.gender_desc'>
                                <!-- <select class="form-control custom-select-sm" v-model="formUpdate.gender_id" :class="{ 'is-invalid': submitBI && $v.formUpdate.gender_id.$error }">
                                    <option value="G202002">Female</option>
                                    <option value="G202001">Male</option>
                                </select> -->
                            </div>
                            <div class="form-group">
                                <label>Civil Status</label>
                                <select class="form-control custom-select-sm" v-model="formUpdate.cs_code" :class="{ 'is-invalid': submitBI && $v.formUpdate.cs_code.$error }">
                                    <option :value="null" disabled>- Select -</option>
                                    <option value="CS001">Single</option>
                                    <option value="CS002">Married</option>
                                    <option value="CS003">Widowed</option>
                                    <option value="CS004">Seperated</option>
                                    <option value="CS006">Annulled</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Place of Birth</label>
                                <input class="form-control form-control-sm" type="text" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)" :value="formUpdate.province_birth + ' ' + formUpdate.city_birth">
                            </div>

                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-outline-primary" data-dismiss="modal" @click="editBI=false">Cancel</button>
                            <button class="btn btn-primary" @click="updateBasicInfo">Update</button>
                        </div>
                    </div>
                </div>
            </div>


            <div class="modal fade" id="modalSpouseInfo" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">>
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title bold">Edit Spouse Information</h5>
                        </div>
                        <div class="modal-body">
                            <div class="form-group">
                                <label>First Name</label>
                                <input class="form-control form-control-sm text-uppercase" type="text" v-model="formUpdate.sp_fname" :class="{ 'is-invalid': submitSP && $v.formUpdate.sp_fname.$error }">
                            </div>
                            <div class="form-group">
                                <label>Middle Name</label>
                                <input class="form-control form-control-sm text-uppercase" type="text" v-model="formUpdate.sp_mname" :class="{ 'is-invalid': submitSP && $v.formUpdate.sp_mname.$error }">
                            </div>
                            <div class="form-group">
                                <label>Last Name</label>
                                <input class="form-control form-control-sm text-uppercase" type="text" v-model="formUpdate.sp_lname" :class="{ 'is-invalid': submitSP && $v.formUpdate.sp_lname.$error }">
                            </div>
                            <div class="form-group">
                                <label>Suffix</label>
                                <select class="form-control custom-select-sm" v-model="formUpdate.sp_suffix">
                                    <option :value="null" disabled>- Select -</option>
                                    <option value="2020001">I</option>
                                    <option value="2020002">II</option>
                                    <option value="2020003">III</option>
                                    <option value="2020004">SR.</option>
                                    <option value="2020005">JR.</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Birth Date</label>
                                <date-range-picker id="sp_bdate" v-model="formUpdate.sp_bdate_holder" class="form-control form-control-sm" :class="{ 'is-invalid': submitSP && $v.formUpdate.sp_bdate_holder.$error }" :max-date="maxBdate" :min-date="minBdate" :start-date="maxBdate" v-input-mask data-inputmask-alias="datetime" :data-inputmask-max="maxBdate" :data-inputmask-min="minBdate" data-inputmask-inputformat="mm/dd/yyyy" placeholder="mm/dd/yyyy"></date-range-picker>
                            </div>

                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-outline-primary" data-dismiss="modal" @click="editSP=false">Cancel</button>
                            <button class="btn btn-primary" @click="updateSpouse">Update</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="modalEmail" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">>
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title bold">Edit Email Address</h5>
                        </div>
                        <div class="modal-body">


                            <div class="alert alert-danger2 alert-dismissible mb-2" role="alert" v-if="error">
                                <button type="button" class="close mt-n1" data-dismiss="alert" @click="error=0">&times;</button>
                                <a target="#err0" hidden id="err"></a>
                                <div class="alert-body">
                                    <p v-if="error_message && errors.length == 0" class="mb-0">
                                        {{ error_message }}
                                    </p>
                                    <div v-for="(v, k) in errors" :key="k">
                                        <p class="mb-0" v-for="item in v" :key="item">{{ item }}</p>
                                    </div>
                                </div>
                            </div>


                            <div class="alert alert-info2">
                                <i class="fas fa-info-circle mr-1 fs-15"></i>Updating Email Address will require email verification.
                            </div>

                            <div class="form-group">
                                <label>Registered Email Address</label>
                                <input class="form-control form-control-sm" type="text" :disabled="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)" :value="formProfile.email">
                            </div>

                            <div class="form-group">
                                <label>New Email Address</label>
                                <input class="form-control form-control-sm text-lowercase" type="email" autocomplete="off" v-model="formUpdate.email_new" :class="{ 'is-invalid': submitEmail && $v.formUpdate.email_new.$error }">
                                <span class="fs-12 text-danger" v-if="$v.formUpdate.email_new.$error && formUpdate.email_new">Please enter a valid email address</span>
                            </div>

                            <div class="form-group">
                                <label>Input your current password to save changes</label>
                                <div class="input-group">
                                    <input :type="showPassword ? 'text' : 'password'" class="form-control form-control-sm" autocomplete="off" v-model="formUpdate.password" :class="{ 'is-invalid': submitEmail && $v.formUpdate.password.$error }">
                                    <div class="input-group-append ml-2">
                                        <button class="btn btn-primary btn-sm" @click="showPassword = !showPassword" type="button"><i :class="[ showPassword ? 'fas fa-eye' : 'fas fa-eye-slash' ]"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-outline-primary" data-dismiss="modal" @click="editEmail=false">Cancel</button>
                            <button class="btn btn-primary" @click="updateEmail">Update</button>
                        </div>
                    </div>
                </div>
            </div>



            <!-- <div class="modal fade" id="updateMobileModal" tabindex="-1" role="dialog" data-backdrop="static">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title bold">Update Mobile Number</h5>

                        </div>

                        <form @submit.prevent="UpdateNewMobileNo('update')">
                            <div class="modal-body">
                                <div class="alert alert-info2 text-justify">
                                    <i class="fas fa-info-circle mr-1 fs-15"></i>Kindly ensure that your mobile number is correctly inputted. A One-Time Pin (OTP) will be sent to this number for verification purposes, and will be used by SBCorp in communicating with you.
                                </div>
                                <div class="form-group">
                                    <label>Input your new mobile number</label>
                                    <input type="text" class="form-control form-control-sm" v-model="new_mobile_number" :class="{ 'is-invalid': submitNewMobile && $v.new_mobile_number.$error }" v-input-mask data-inputmask-mask="(9999) 9999999" data-inputmask-placeholder="">
                                    <em class="fs-13">Ex. (0912) 3456789</em>
                                    <p class="fs-13 danger m-0 p-0" v-if="submitNewMobile && $v.new_mobile_number.$error">Not a valid Mobile Number</p>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="submit" class="btn btn-outline-primary" data-dismiss="modal">Cancel</button>
                                <button type="submit" class="btn btn-primary">Update</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div> -->


            <div class="modal fade" id="modalMobile" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">>
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title bold">Edit Mobile Number</h5>
                        </div>

                        <div class="modal-body">
                            <!-- <div class="alert alert-warning2">
                                <i class="fas fa-info-circle mr-1 fs-15"></i>Not available at the moment.
                            </div> -->

                            <div class="alert alert-info2 text-justify">
                                <i class="fas fa-info-circle mr-1 fs-15"></i>Kindly ensure that your mobile number is correctly inputted. A One-Time Pin (OTP) will be sent to this number for verification purposes, and will be used by SBCorp in communicating with you.
                            </div>

                            <div class="alert alert-danger2 alert-dismissible mb-2" v-if="same_mobile">
                                <button type="button" class="close mt-n1" data-dismiss="alert" aria-hidden="true" @click="same_mobile=false">&times;</button>
                                <span>You've entered same mobile number</span>
                            </div>
                            <div class="alert alert-danger2 alert-dismissible mb-2" v-if="errorStatus">
                                <button type="button" class="close mt-n1" data-dismiss="alert" aria-hidden="true" @click="errorStatus=false">&times;</button>
                                <span>{{errorMsg}}</span>
                            </div>


                            <div class="form-group">
                                <label>New Mobile Number</label>
                                <input class="form-control form-control-sm" @paste="pasteMobile" ref="mobile_new" :class="{ 'is-invalid': submitMobile && $v.formMobile.mobile_number.$error }" type="text" autocomplete="off" v-model="formMobile.mobile_number" v-input-mask data-inputmask-mask="(9999) 9999999" data-inputmask-placeholder="">
                                <p class="fs-13 danger m-0 p-0" v-if="submitMobile && $v.formMobile.mobile_number.$error">Not a valid Mobile Number</p>
                            </div>


                            <div class="form-group">
                                <label>Input your current password to save changes</label>
                                <div class="input-group">
                                    <input :type="showPassword ? 'text' : 'password'" class="form-control form-control-sm" :class="{ 'is-invalid': submitMobile && $v.formMobile.password.$error }" autocomplete="new-password" v-model="formMobile.password">
                                    <div class="input-group-append ml-2">
                                        <button class="btn btn-primary btn-sm" @click="showPassword = !showPassword" type="button"><i :class="[ showPassword ? 'fas fa-eye' : 'fas fa-eye-slash' ]"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-outline-primary" data-dismiss="modal">Cancel</button>
                            <button class="btn btn-primary" @click="updateMobile">Update</button>
                        </div>

                    </div>
                </div>
            </div>


            <div class="modal fade" id="modalAddress" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">>
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title bold">Edit Address</h5>
                        </div>
                        <div class="modal-body">
                            <div class="form-group">
                                <label>Province</label>
                                <v-select label="province" :options="provinces" :reduce="province => province.province_code" :clearable="false" v-model="formUpdate.province_code" @input="getCity(formUpdate.province_code), formUpdate.city_code='',formUpdate.bcode=''" :class="{'vs-invalid': submitAdd && $v.formUpdate.province_code.$error }"></v-select>
                            </div>
                            <div class="form-group">
                                <label>City/Municipality</label>
                                <v-select label="city" :options="cities" :reduce="city => city.city_code" :clearable="false" v-model="formUpdate.city_code" @input="getBrgy(formUpdate.city_code), formUpdate.bcode=''" :class="{'vs-invalid': submitAdd && $v.formUpdate.city_code.$error }"></v-select>
                            </div>
                            <div class="form-group">
                                <label>Barangay</label>
                                <v-select label="bname" :options="brgys" :reduce="bname => bname.bcode" :clearable="false" v-model="formUpdate.bcode" :class="{'vs-invalid': submitAdd && $v.formUpdate.bcode.$error }"></v-select>
                            </div>

                            <div class="form-group">
                                <label>House No/Block & Lot/Building</label>
                                <input class="form-control form-control-sm text-uppercase" type="text" v-model="formUpdate.bldg" :class="{ 'is-invalid': submitAdd && $v.formUpdate.bldg.$error }">
                            </div>

                            <div class="form-group">
                                <label>Street Name / Subdivision</label>
                                <input class="form-control form-control-sm text-uppercase" type="text" v-model="formUpdate.street_address" :class="{ 'is-invalid': submitAdd && $v.formUpdate.street_address.$error }">
                            </div>


                            <div class="form-group">
                                <label>Ownership</label>
                                <select class="form-control custom-select-sm text-uppercase" v-model="formUpdate.add_ship" :class="{ 'is-invalid': submitAdd && $v.formUpdate.add_ship.$error }">
                                    <option :value="null" disabled>- Select -</option>
                                    <option value="1">Owned</option>
                                    <option value="2">Rented</option>
                                    <option value="3">Living with parents</option>
                                    <option value="4">Living with relatives</option>
                                </select>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-outline-primary" data-dismiss="modal" @click="copyProfile, editAdd=false">Cancel</button>
                            <button class="btn btn-primary" @click="updateAddress">Update</button>
                        </div>
                    </div>
                </div>
            </div>




            <div class="modal fade" id="modalBus" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">>
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title bold">Edit Business Info</h5>
                        </div>
                        <div class="modal-body">

                            <div class="form-group">
                                <label>Business Name</label>
                                <input class="form-control form-control-sm text-uppercase" type="text" v-model="formBus2.business_name" :class="{ 'is-invalid': submitBus && $v.formBus2.business_name.$error }">
                            </div>

                            <div class="form-group">
                                <label>Total Years in Business</label>
                                <input class="form-control form-control-sm text-uppercase" type="text" v-model="formBus2.total_years" :class="{ 'is-invalid': submitBus && $v.formBus2.total_years.$error }" v-input-mask data-inputmask-alias="decimal" maxlength="6" data-inputmask-digits="2" data-inputmask-radixPoint="." data-inputmask-placeholder="" data-inputmask-rightAlign="false" placeholder="">
                                <span class="fs-12">(e.g 2 years and 6 months = 2.6)</span>
                            </div>

                            <div class="form-group">
                                <label>Province</label>
                                <v-select label="province" :options="provinces" :reduce="province => province.province_code" :clearable="false" v-model="formBus2.bus_province_code" @input="getCity(formBus2.bus_province_code), formBus2.bus_city_code='',formBus2.bus_bcode=''" :class="{'vs-invalid': submitAdd && $v.formBus2.bus_province_code.$error }"></v-select>
                            </div>
                            <div class="form-group">
                                <label>City/Municipality</label>
                                <v-select label="city" :options="cities" :reduce="city => city.city_code" :clearable="false" v-model="formBus2.bus_city_code" @input="getBrgy(formBus2.bus_city_code), formBus2.bus_bcode=''" :class="{'vs-invalid': submitAdd && $v.formBus2.bus_city_code.$error }"></v-select>
                            </div>
                            <div class="form-group">
                                <label>Barangay</label>
                                <v-select label="bname" :options="brgys" :reduce="bname => bname.bcode" :clearable="false" v-model="formBus2.bus_bcode" :class="{'vs-invalid': submitBus && $v.formBus2.bus_bcode.$error }"></v-select>
                            </div>

                            <div class="form-group">
                                <label>House No/Block & Lot/Building</label>
                                <input class="form-control form-control-sm text-uppercase" type="text" v-model="formBus2.bus_bldg" :class="{ 'is-invalid': submitBus && $v.formBus2.bus_bldg.$error }">
                            </div>

                            <div class="form-group">
                                <label>Street Name / Subdivision</label>
                                <input class="form-control form-control-sm text-uppercase" type="text" v-model="formBus2.bus_street_address" :class="{ 'is-invalid': submitBus && $v.formBus2.bus_street_address.$error }">
                            </div>


                            <div class="form-group">
                                <label>Ownership</label>
                                <select class="form-control custom-select-sm text-uppercase" v-model="formBus2.add_ship" :class="{ 'is-invalid': submitBus && $v.formBus2.add_ship.$error }">
                                    <option :value="null" disabled>- Select -</option>
                                    <option value="1">Owned</option>
                                    <option value="2">Rented</option>
                                    <option value="3">Living with parents</option>
                                    <option value="4">Living with relatives</option>
                                </select>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-outline-primary" data-dismiss="modal" @click="copyBusiness">Cancel</button>
                            <button class="btn btn-primary" @click="updateBus">Update</button>
                        </div>
                    </div>
                </div>
            </div>





            <!-- MODAL OTP -->
            <div class="modal fade" id="generateOTP" tabindex="-1" role="dialog" aria-labelledby="generateOTP" aria-hidden="true" data-backdrop="static" data-keyboard="false">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="generateOTP">One-Time-Pin Verification</h5>
                        </div>
                        <div class="modal-body">



                            <center>
                                <p>Kindly enter below the OTP we have sent to your mobile number <b>{{formMobile.mobile_number}}</b> to verify your identity.</p>
                                <p>It will expire in the next <strong>10 minutes </strong></p>

                                <div class="alert alert-danger2 alert-dismissible mb-1" v-if="formOTP.invalid">
                                    <button type="button" class="close mt-n1" data-dismiss="alert" aria-hidden="true" @click="formOTP.invalid=false">&times;</button>
                                    <span>Invalid verification code entered!</span>
                                </div>

                                <p><b>Enter the 6-digit you received</b></p>
                                <div class="form-group">
                                    <div class="otp d-flex justify-content-center">
                                        <input inputmode="numeric" autofocus class="p-2 text-center form-control " type="text" maxlength="6" v-model="formOTP.code" :class="{ 'is-invalid': submitOTP && $v.formOTP.code.$error }" />
                                    </div>
                                    <p class="fs-13 danger m-0 p-0" v-if="submitOTP && $v.formOTP.code.$error">Not a valid verification code</p>
                                </div>
                            </center>

                            <button type="button" class="btn btn-link" :disabled="counting" @click="resendOTP">
                                <countdown v-if="counting" :time="600000" @end="handleCountdownEnd">
                                    <template slot-scope="props">Resend again {{ props.minutes }} minutes, {{ props.seconds }} seconds later</template>
                                </countdown>
                                <span v-else>Did not received OTP? Click here to resend code</span>
                            </button>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-outline-primary mr-auto" data-dismiss="modal">Cancel</button>

                            <button type="button" class="btn btn-primary" ref="otpSubmit" @click='verifyOTP'>Verify</button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- MODAL OTP -->

        </section>










    </div>
</template>
<script>
    import moment from 'moment'
    import {
        Form
    } from 'vform';
    import vSelect from 'vue-select'
    Vue.component('v-select', vSelect)
    import {
        required,
        requiredIf,
        minLength,
        email
    } from "vuelidate/lib/validators";

    export default {

        data() {
            return {

                error: false,
                errors: [],
                error_message: '',

                counting: false,
                same_mobile: false,
                new_mobile_number: null,
                maxBdate: moment().subtract(18, "years").format("MM/DD/YYYY"),
                minBdate: '01/01/1900',

                provinces: [],
                cities: [],
                brgys: [],
                readonly: true,
                showPassword: false,
                errorStatus: false,
                errorMsg: null,

                editBI: false,
                editEmail: false,
                editAdd: false,
                editBus: false,
                editSP: false,

                submitBI: false,
                submitSP: false,
                submitEmail: false,
                submitAdd: false,
                submitBus: false,
                submitMobile: false,
                submitOTP: false,


                formBus: new Form({
                    borrower_id: null,
                    business_name: null,
                    bus_bldg: null,
                    bus_street_address: null,
                    bus_bcode: null,
                    bus_bname: null,
                    bus_city_code: null,
                    bus_city: null,
                    bus_province_code: null,
                    bus_province: null,
                    add_ship: null,
                    owner_desc: null,
                    total_years: null,
                }),

                formBus2: new Form({
                    borrower_id: null,
                    business_name: null,
                    bus_bldg: null,
                    bus_street_address: null,
                    bus_bcode: null,
                    bus_bname: null,
                    bus_city_code: null,
                    bus_city: null,
                    bus_province_code: null,
                    bus_province: null,
                    add_ship: null,
                    owner_desc: null,
                    total_years: null,
                }),



                formUpdate: new Form({
                    borrower_id: null,
                    fname: null,
                    lname: null,
                    mname: null,
                    suffix_code: null,
                    suffix_desc: null,
                    date_birth: null,
                    place_birth: null,
                    city_birth: null,
                    province_code_birth: null,
                    province_birth: null,
                    gender_id: null,
                    gender_desc: null,
                    cs_code: null,
                    cs_desc: null,
                    sp_fname: null,
                    sp_lname: null,
                    sp_mname: null,
                    sp_suffix: null,
                    sp_suffix_desc: null,
                    sp_date_birth: null,
                    id_code: null,
                    id_name: null,
                    issue_date: null,
                    id_number: null,
                    bldg: null,
                    street_address: null,
                    bcode: null,
                    bname: null,
                    city_code: null,
                    city: null,
                    province_code: null,
                    province: null,
                    add_ship: null,
                    owner_desc: null,
                    bt_code: null,
                    email: null,
                    mobile_number: null,
                    tel_number: null,
                    addl_contact_type: null,
                    addl_contact: null,

                    //contact info
                    password: null,
                    email_new: null,
                    mobile_new: null,

                    bdate_holder: null,
                    sp_bdate_holder: null,
                    s_sp_date_birth: null,

                }),


                formMobile: new Form({
                    borrower_id: null,
                    mobile_number: null,
                    password: null,
                }),

                formProfile: new Form({
                    borrower_id: null,
                    fname: null,
                    lname: null,
                    mname: null,
                    suffix_code: null,
                    suffix_desc: null,
                    date_birth: null,
                    place_birth: null,
                    city_birth: null,
                    province_code_birth: null,
                    province_birth: null,
                    gender_id: null,
                    gender_desc: null,
                    cs_code: null,
                    cs_desc: null,
                    sp_fname: null,
                    sp_lname: null,
                    sp_mname: null,
                    sp_suffix: null,
                    sp_suffix_desc: null,
                    sp_date_birth: null,
                    id_code: null,
                    id_name: null,
                    issue_date: null,
                    id_number: null,
                    bldg: null,
                    street_address: null,
                    bcode: null,
                    bname: null,
                    city_code: null,
                    city: null,
                    province_code: null,
                    province: null,
                    add_ship: null,
                    owner_desc: null,
                    bt_code: null,
                    email: null,
                    mobile_number: null,
                    tel_number: null,
                    addl_contact_type: null,
                    addl_contact: null,

                    //contact info
                    password: null,
                    email_new: null,
                    mobile_new: null,

                    bdate_holder: null,
                    sp_bdate_holder: null,
                    s_sp_date_birth: null,
                }),


                formOTP: new Form({
                    code: null,
                    invalid: false,
                    sent: false,
                }),
                session_id: null,


                api: {
                    city: false,
                    brgy: false,
                    province: false,
                    bor_det: false,
                    update: false,
                    bus: false,
                    otp: false,
                }

            } //return
        }, //data
        validations: {

            formMobile: {
                mobile_number: {
                    required,
                    minLength: minLength(14)
                },
                password: {
                    required
                }
            },
            formUpdate: {
                cs_code: {
                    required: requiredIf(function() {
                        return this.editBI;
                    })
                },
                gender_id: {
                    required: requiredIf(function() {
                        return this.editBI;
                    })
                },
                email_new: {
                    email,
                    required: requiredIf(function() {
                        return this.editEmail;
                    })
                },
                password: {
                    required: requiredIf(function() {
                        return this.editEmail;
                    })
                },
                province_code: {
                    required: requiredIf(function() {
                        return this.editAdd;
                    })
                },
                city_code: {
                    required: requiredIf(function() {
                        return this.editAdd;
                    })
                },
                bcode: {
                    required: requiredIf(function() {
                        return this.editAdd;
                    })
                },
                street_address: {
                    required: requiredIf(function() {
                        return this.editAdd;
                    })
                },
                bldg: {
                    required: requiredIf(function() {
                        return this.editAdd;
                    })
                },
                add_ship: {
                    required: requiredIf(function() {
                        return this.editAdd;
                    })
                },

                sp_fname: {
                    required: requiredIf(function() {
                        return this.editSP;
                    })
                },
                sp_mname: {
                    required: requiredIf(function() {
                        return this.editSP;
                    })
                },
                sp_lname: {
                    required: requiredIf(function() {
                        return this.editSP;
                    })
                },
                sp_bdate_holder: {
                    required: requiredIf(function() {
                        return this.editSP;
                    })
                },

            },
            formBus2: {
                business_name: {
                    required
                },
                bus_bldg: {
                    required
                },
                bus_street_address: {
                    required
                },
                bus_bcode: {
                    required
                },
                bus_city_code: {
                    required
                },
                bus_province_code: {
                    required
                },
                add_ship: {
                    required
                },
                total_years: {
                    required
                },
            },
            formOTP: {
                code: {
                    required,
                    minLength: minLength(6)
                },
            }
        },
        methods: {

            showMobileNo() {
                this.formMobile.reset();
                this.formOTP.reset();
                this.counting = false;
                this.submitOTP = false;
                this.submitMobile = false;
                $('#modalMobile').modal('show');
            },


            verifyOTP() {
                this.submitOTP = true
                this.$v.formOTP.$touch();
                if (this.$v.formOTP.$invalid) {
                    this.requiredField();
                } else {
                    this.api.otp = true;
                    axios.post('api/c3-profile-verify-otp', {
                            mobile_number: this.new_mobile_number,
                            verification_code: this.formOTP.code,
                            borrower_id: this.formProfile.borrower_id,
                            mobile_no: this.formMobile.mobile_number,
                            session_id: this.session_id
                        })
                        .then(response => {
                            this.api.otp = false;
                            if (response.data.status == 0) {
                                this.formOTP.invalid = true;
                                setTimeout(() => {
                                    this.formOTP.invalid = false;
                                }, 5000);
                            } else {
                                $('#generateOTP').modal('hide');
                                this.getBorDetail();
                            }
                        }).catch(error => {
                            this.api.otp = false;
                            console.log(error);
                        })
                }
            },

            resendOTP: _.debounce(function() {
                this.generateOTP();
            }, 500),

            generateOTP() {
                this.api.otp = true;
                axios.post('api/c3-profile-generate-otp', {
                        mobile_number: this.new_mobile_number
                    })
                    .then(response => {
                        this.api.otp = false;
                        this.counting = true;
                        this.session_id = response.data.session_id;

                    }).catch(error => {
                        this.api.otp = false;
                        Swal.fire({
                            icon: 'info',
                            text: 'Please try again later.',
                            title: 'Too many requests',
                            allowEscapeKey: false,
                            allowOutsideClick: false,
                        });
                        console.log(error);
                    })
            },

            handleCountdownEnd: function() {
                this.counting = false;
            },

            pasteMobile() {
                setTimeout(() => {
                    this.formMobile.mobile_number = this.$refs["mobile_new"].value;
                }, 100);
            },


            updateMobile() {
                this.submitMobile = true
                this.$v.formMobile.$touch();
                if (this.$v.formMobile.$invalid) {
                    this.requiredField();
                } else {

                    if (this.formMobile.mobile_number == this.formProfile.mobile_number) {
                        this.same_mobile = true;
                    } else {

                        let number = this.formMobile.mobile_number;
                        number = number.replace(/[^\d]/g, '');

                        this.new_mobile_number = '+63' + number.substring(1);

                        setTimeout(() => {
                            this.api.update = true;
                            axios.post('api/c3-check-password', {
                                    password: this.formMobile.password,
                                    mobile_number: this.new_mobile_number,
                                })
                                .then(response => {
                                    this.api.update = false;
                                    if (response.data.status == 1) {
                                        $('#modalMobile').modal('hide');
                                        $('#generateOTP').modal('show');
                                        this.counting = true;
                                        this.session_id = response.data.session_id;

                                    } else {
                                        this.errorStatus = true;
                                        this.errorMsg = response.data.msg;
                                        setTimeout(() => {
                                            this.errorStatus = false;
                                        }, 5000);
                                    }
                                }).catch(error => {
                                    this.api.update = false;
                                })

                        }, 300);

                    }

                }
            },

            requiredField() {
                Swal.fire({
                    icon: 'warning',
                    title: 'Validation',
                    text: 'Please fill-out all required fields',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                })
            },
            updateEmail() {
                this.submitEmail = true
                this.error = 0;
                this.$v.formUpdate.$touch();
                if (this.$v.formUpdate.$invalid) {
                    this.requiredField();
                } else {
                    this.api.update = true;
                    axios.post('api/c3-update-email', {
                            borrower_id: this.formProfile.borrower_id,
                            email: this.formProfile.email,
                            email_new: this.formUpdate.email_new,
                            password: this.formUpdate.password,
                        })
                        .then(res => {
                            this.api.update = false;
                            this.editEmail = false;
                            this.error = 0;
                            const message = res.data.message;
                            $('#modalEmail').modal('hide');

                            axios.post("/logout");
                            Swal.fire({
                                title: 'Success',
                                text: message,
                                icon: 'success',
                                allowEscapeKey: false,
                                allowOutsideClick: false,
                            }).then((result) => {
                                location.href = '/login';
                            })

                        }).catch(err => {
                            this.error = 1;
                            if (err.response && err.response.data) {
                                this.errors = err.response.data.errors || [];
                                this.error_message = err.response.data.message;
                            }
                            this.api.update = false;
                        })
                }
            },

            updateBus() {
                this.submitBus = true
                this.$v.formBus2.$touch();
                if (this.$v.formBus2.$invalid) {
                    this.requiredField();
                } else {
                    this.api.update = true;
                    this.formBus2.post('api/c3-update-business')
                        .then(response => {
                            $('#modalBus').modal('hide');
                            this.api.update = false;
                            this.getBusinessInfo(this.formProfile.borrower_id);
                            this.toastMessage('Business Information has been updated');
                        }).catch(error => {
                            this.api.update = false;
                        })
                }
            },
            updateAddress() {
                this.submitAdd = true
                this.$v.formUpdate.$touch();
                if (this.$v.formUpdate.$invalid) {
                    this.requiredField();
                } else {
                    this.api.update = true;
                    this.formUpdate.post('api/c3-update-address')
                        .then(response => {
                            $('#modalAddress').modal('hide');
                            this.api.update = false;
                            this.editAdd = false;
                            this.getBorDetail();
                            this.toastMessage('Address Information has been updated');
                        }).catch(error => {
                            this.api.update = false;
                        })
                }
            },

            updateSpouse() {
                this.submitSP = true
                this.$v.formUpdate.$touch();

                if (this.$v.formUpdate.$invalid) {
                    this.requiredField();
                } else {
                    this.api.update = true;
                    if (this.formUpdate.sp_bdate_holder) {
                        let spouse_bdate = moment(this.formUpdate.sp_bdate_holder, 'MM/DD/YYYY');
                        this.formUpdate.sp_date_birth = spouse_bdate.format('YYYY-MM-DD');
                    }
                    this.formUpdate.post('api/c3-update-spouse')
                        .then(response => {
                            $('#modalSpouseInfo').modal('hide');
                            this.api.update = false;
                            this.editSP = false;
                            this.getBorDetail();

                            this.toastMessage('Spouse Information has been updated');
                        }).catch(error => {
                            this.api.update = false;
                        })
                }
            },



            updateBasicInfo() {
                this.submitBI = true
                this.$v.formUpdate.$touch();
                if (this.$v.formUpdate.$invalid) {
                    this.requiredField();
                } else {
                    this.api.update = true;
                    this.formUpdate.post('api/c3-update-basic-info')
                        .then(response => {
                            $('#modalBasicInfo').modal('hide');
                            this.api.update = false;
                            this.editBI = false;
                            this.getBorDetail();
                            this.toastMessage('Basic Information has been updated');
                            // Swal.fire({
                            //     title: 'Success',
                            //     text: "Basic Information has been updated",
                            //     icon: 'success',
                            //     allowEscapeKey: false,
                            //     allowOutsideClick: false,
                            // }).then((result) => {
                            //     let x = document.getElementsByTagName("BODY")[0];
                            //     x.style.paddingRight = '0px !important';
                            // })
                        }).catch(error => {
                            this.api.update = false;
                        })
                }

            },
            toastMessage(msg) {
                toast.fire({
                    icon: 'success',
                    text: msg
                });
            },


            copyProfile() {
                for (let key in this.formProfile) {
                    this.formUpdate[key] = this.formProfile[key];
                }
            },
            copyBusiness() {
                for (let key in this.formBus) {
                    this.formBus2[key] = this.formBus[key];
                }
            },


            showModalBusiness: async function(event) {
                await this.getProvince();
                await this.getCity(this.formBus.bus_province_code);
                await this.getBrgy(this.formBus.bus_city_code);
                await $('#modalBus').modal('show');
            },

            showModalAddress: async function(event) {
                await this.getProvince();
                await this.getCity(this.formProfile.province_code);
                await this.getBrgy(this.formProfile.city_code);
                await $('#modalAddress').modal('show');
                this.editAdd = true;
            },


            handler($event) {
                if (this.readonly) {
                    $event.preventDefault();
                    // event.stopPropagation();
                }
                // return false;
            },

            getBusinessInfo(id) {
                this.api.bus = true;
                this.formBus.reset();
                this.formBus2.reset();
                axios.get('api/c3-prof-get-business', {
                        params: {
                            borrower_id: id
                        }
                    })
                    .then(response => {
                        if (response.data.length > 0) {
                            this.formBus.fill(response.data[0]);
                            this.copyBusiness();
                        }
                        this.api.bus = false;
                    })
                    .catch((error) => {
                        this.api.bus = false;
                        console.log(error);
                    })
            },

            getBorDetail() { // borrower, address, spouse, id, contact

                this.formProfile.reset();
                this.formUpdate.reset();
                this.api.bor_det = true;
                axios.get('api/c3-prof-get-bor-det')
                    .then(response => {
                        this.api.bor_det = false;
                        if (response.data.length > 0) {
                            this.formProfile.fill(response.data[0]);
                            let clientDate = moment(this.formProfile.date_birth, 'YYYY-MM-DD');
                            this.formProfile.bdate_holder = clientDate.format('MM/DD/YYYY');
                            if (this.formProfile.sp_date_birth) {
                                let spouse_bdate = moment(this.formProfile.sp_date_birth, 'YYYY-MM-DD');
                                this.formProfile.sp_bdate_holder = spouse_bdate.format('MM/DD/YYYY');
                            }

                            setTimeout(() => {
                                this.copyProfile();
                                this.getBusinessInfo(this.formProfile.borrower_id);
                            }, 700);

                        }
                    })
                    .catch(error => {
                        this.api.bor_det = false;

                    })
            },


            //Ref APIS
            getCity(val) {
                this.api.city = true;
                axios.get('api/ref-prov-cities', {
                        params: {
                            province_code: val
                        }
                    })
                    .then(response => {
                        this.cities = response.data;
                        this.api.city = false;
                    })
                    .catch((error) => {
                        this.api.city = false;
                        console.log(error);
                    })
            },
            getBrgy(val) {
                this.api.brgy = true;
                axios.get('api/ref-city-brgy', {
                        params: {
                            city_code: val
                        }
                    })
                    .then(response => {

                        this.brgys = response.data;
                        this.api.brgy = false;
                    })
                    .catch((error) => {

                        console.log(error);
                        this.api.brgy = false;
                    })
            },

            getProvince() {
                this.api.province = true;
                axios.get('/api/ref-provinces')
                    .then(response => {
                        this.provinces = response.data
                        this.api.province = false;
                    })
                    .catch(error => {
                        console.log(error);
                        this.api.province = false;
                    })
            },


        },
        created() {
            this.getBorDetail();

            Fire.$on('ProfileUpdated', () => {
                this.getBorDetail();
            });
        },

        computed: {
            processingAPI() {
                return Object.values(this.api).includes(true);
            },

        }
    }
</script>
<style scoped>
    .input-group>.input-group-append>.btn,
    .input-group>.input-group-append>.input-group-text,
    .input-group>.input-group-prepend:first-child>.btn:not(:first-child),
    .input-group>.input-group-prepend:first-child>.input-group-text:not(:first-child),
    .input-group>.input-group-prepend:not(:first-child)>.btn,
    .input-group>.input-group-prepend:not(:first-child)>.input-group-text {
        border-top-left-radius: .25rem !important;
        border-bottom-left-radius: .25rem !important;
    }

    .input-group>.custom-select:not(:last-child),
    .input-group>.form-control:not(:last-child) {
        border-top-right-radius: .25rem !important;
        border-bottom-right-radius: .25rem !important;
    }



    .otp .form-control {
        width: 150px;
        height: 50px;
        font-size: 20px;
    }
</style>